import { endpoints } from "consts";

export const authUrlBuilder = {
  authRequest: (): string => {
    return `${endpoints.auth}`;
  },
};
